// extracted by mini-css-extract-plugin
module.exports = {"container":"ImageTextBlock-module--container--3W_8C"};